import { BaseRouteService } from "./BaseRouteService";

export class LoginService extends BaseRouteService {
    public async login(username: string, password: string): Promise<{ success: boolean; sessionId?: string }> {
        try {
            console.log("[LoginService] Attempting login:", { username });

            const response: {
                message?: string;
                sessionId?: string;
                error?: string;
            } = await this.postJsonApi("game/login", {
                username,
                password,
            });

            console.log("[LoginService] Login response:", response);

            if (response.sessionId) {
                console.log("[LoginService] Login success. Received sessionId:", response.sessionId);
                return {
                    success: true,
                    sessionId: response.sessionId,
                };
            }

            console.warn("[LoginService] Login failed. Server response:", response);
            return { success: false };
        }
        catch (error: unknown) {
            const err: Error = error as Error;
            console.error("[LoginService] Fout tijdens login:", err.message);
            return { success: false };
        }
    }
}
